import { useCallback } from 'react';
import { prop } from 'ramda';

import { useAppSelector } from 'js/store/hooks';

import { fetchDepositLimits } from '../server';

export const useDepositLimits = () => {
    const casinoName = useAppSelector(prop('casinoName'));

    return useCallback(async () => fetchDepositLimits({ casinoName }), [casinoName]);
};
